export { ActivationAssignedStatus } from './generated/ActivationAssignedStatus.js';